import { SendJapaneseEmailVariables, SendJapaneseEmail } from '../../types/'
import { useMutation } from '@apollo/client'
import { SEND_JAPANESE_EMAIl } from './operations'

export const useSendJapaneseEmail = () =>
  useMutation<SendJapaneseEmail, SendJapaneseEmailVariables>(SEND_JAPANESE_EMAIl)
